import { render, staticRenderFns } from "./NacionalidadTabContent.vue?vue&type=template&id=68e035e8"
import script from "./NacionalidadTabContent.vue?vue&type=script&lang=js"
export * from "./NacionalidadTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports